import { max } from 'lodash';
import React, { useEffect, useState, useRef } from 'react';

import { useSections } from '../FreeformAnalysisForm/FreeformAnalysisFormContext';
import {
  setCurrentSections,
  setSectionToScroll,
} from '../FreeformAnalysisForm/FreeformAnalysisFormContextUtils';
import { DRAG_AND_DROP_STATE_ACTION } from '../FreeformAnalysisForm/FreeformAnalysisFormUtil/dragAndDropReducer';

import AddReportDataLayoutContainer from './AddReportDataLayoutContainer/AddReportDataLayoutContainer';
import './FreeformAnalysisLayout.scss';
import './FreeformAnalysisLayoutContainer.scss';

const FreeformAnalysisLayout = ({
  droppableLocations,
  libraryItemMap,
  handleDragEnd,
  setDroppableLocations,
  analysisTitle,
  analysisDescription,
  tags,
}) => {
  const [{ currentSections }, dispatch] = useSections();
  const handleAddSection = () => {
    const maxSectionOrder = max(
      currentSections.map((section) => section.order)
    );
    const previousSection = currentSections.find(
      (s) => s.order === maxSectionOrder
    );
    const newSection = {
      order: maxSectionOrder + 1,
      layoutType: previousSection.layoutType,
      items: [],
    };

    setCurrentSections([...currentSections, newSection], dispatch);
    setSectionToScroll(maxSectionOrder, dispatch);
  };

  const updateCurrentPosition = (position, itemId) => {
    dispatch({
      type: DRAG_AND_DROP_STATE_ACTION.ITEM_MOVED_WITHIN_SECTION,
      payload: {
        currentPosition: position,
        draggableWithinSectionsItemId: itemId,
      },
    });
  };

  const mouse = useRef(null);
  const handleMouseMove = (e) => {
    mouse.current = e;
  };

  useEffect(() => {
    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  const [draggedItem, setDraggedItem] = useState(null);
  // dragMode SNAP = keyboard see https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/responders.md#ondragstart
  const addRemoveThumbNailClass = (draggableId, cssClass, dragMode) => {
    const draggableDiv = document.querySelector(
      `[data-rbd-draggable-id="${draggableId}"]`
    ).children[0];

    if (draggableDiv) {
      draggableDiv.setAttribute('class', cssClass);

      if (dragMode !== 'SNAP') {
        const position = draggableDiv.getBoundingClientRect();
        draggableDiv.style.left = `${mouse.current.clientX - position.left}px`;
        draggableDiv.style.top = `${mouse.current.clientY - position.top}px`;
        draggableDiv.style.position = 'absolute';
      }
      setDraggedItem(draggableDiv);
    }
  };

  const handleOnDragStart = ({ source, draggableId, mode }) => {
    addRemoveThumbNailClass(draggableId, 'library-item-card2 thumb-nail', mode);

    updateCurrentPosition(source, draggableId);
  };
  const handleOnDragUpdate = ({ destination, draggableId }) => {
    updateCurrentPosition(destination, draggableId);
  };

  const onDragEndWrapper = ({ destination, source, draggableId }) => {
    addRemoveThumbNailClass(draggableId, 'library-item-card2');
    handleDragEnd({ destination, source, draggableId, draggedItem });
  };

  return (
    <div className="drag-and-drop-layout">
      <AddReportDataLayoutContainer
        onDragStart={handleOnDragStart}
        onDragUpdate={handleOnDragUpdate}
        onDragEnd={onDragEndWrapper}
        libraryItemMap={libraryItemMap}
        droppableLocations={droppableLocations}
        onAddNewSection={handleAddSection}
        setDroppableLocations={setDroppableLocations}
        analysisTitle={analysisTitle}
        analysisDescription={analysisDescription}
        tags={tags}
      />
    </div>
  );
};

export default FreeformAnalysisLayout;
